import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteExpenseItemQuery = (id) => {
  return axios.post(`${apiurl?.deleteExpenseItem}?expenseLineItemID=${id}`);
};

const deleteExpenseItem = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteExpenseItemQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getexpenseitemlist');
    }
  });
};

export default deleteExpenseItem;
